import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './MatrixTable.css';

// Matritsa jadval: qatorlar × ustunlar, har katakda tayyor ReactNode (masalan Badge).
// columns: [{ key, label }]; rows: [{ key?, label, cells: { [columnKey]: node } }]
const MatrixTable = forwardRef(function MatrixTable(
  { columns = [], rows = [], rowHeader = '', emptyCell = '—', className, ...rest },
  ref
) {
  return (
    <div {...rest} ref={ref} className={cx('ui-table-wrap', 'ui-matrix', className)}>
      <table className="ui-table">
        <thead>
          <tr>
            <th scope="col">{rowHeader}</th>
            {columns.map((column) => (
              <th key={column.key} scope="col" className="ui-matrix__col">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.key ?? `${row.label}-${index}`}>
              <th scope="row" className="ui-matrix__row">
                {row.label}
              </th>
              {columns.map((column) => {
                const cell = row.cells?.[column.key];
                return (
                  <td key={column.key} className="ui-matrix__cell">
                    {cell === undefined || cell === null || cell === '' ? (
                      <span className="ui-matrix__empty">{emptyCell}</span>
                    ) : (
                      cell
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default MatrixTable;
